import { ZAttribute } from "src/types/ZAttribute";
import { ZGroup } from "src/types/ZGroup";
import { NodeId, TreeNode, attributeNode, groupNode } from "../model/node";

/**
 * Дети одного уровня по данным, пришедшим с сервера.
 *
 * По умолчанию вложения значений справочника не выводятся на уровне объекта.
 * Внутри мнемонической группы показываем все её дочерние группы: иначе
 * оставшийся valueId делает существующую группу недоступной для управления.
 */
export const childNodesOf = (
  ownerId: NodeId,
  attributes: ZAttribute[] | null | undefined,
  groups: ZGroup[] | null | undefined,
  { includeValueGroups = false }: { includeValueGroups?: boolean } = {},
): TreeNode[] => [
  ...(attributes ?? [])
    .filter(({ valueId }) => !valueId)
    .map((attr) => attributeNode(attr, ownerId)),
  ...(groups ?? [])
    .filter(({ valueId }) => includeValueGroups || !valueId)
    .map((group) => groupNode(group, ownerId)),
];
